import { render, staticRenderFns } from "./ShopPageCateogry.vue?vue&type=template&id=50bff47b"
import script from "./ShopPageCateogry.vue?vue&type=script&lang=js"
export * from "./ShopPageCateogry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports